<template>
  <Modal
    class="team-picker-dialog text-left"
    v-model="shown"
    :title="title"
    :footer="false"
    :append-to-body="true"
  >
    <div style="width: 100%">
      <div class="row">
        <div class="col-sm-12">
          <div class="row">
            <!-- List -->
            <div class="col-sm-12">
              <div class="list-container" ref="list">
                <a
                  v-for="(team, index) in teams"
                  :key="team.id"
                  class="list-item a-no-highlight"
                  :href="getTeamHomeUrl(team)"
                  :class="{ selected: team === selection }"
                  @click="handleTeamClick(team)"
                  :data-test="`team-link-${index}`"
                >
                  <div class="team-image-container">
                    <img
                      :src="team.imageUrl"
                      class="team-image team-image-border"
                      alt="team image"
                    />
                  </div>
                  <span class="team-name">
                    {{ team.name }}
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script setup lang="ts">
import { ref, computed } from "vue";
import { Modal } from "uiv";

import { TeamApiModel } from "../api-models";

const props = withDefaults(
  defineProps<{
    teams: TeamApiModel[];
    canCreateTeams: boolean;
    selection?: TeamApiModel | null;
    navigateOnClick?: boolean;
  }>(),
  {
    selection: null,
    navigateOnClick: true,
  },
);
const emit = defineEmits(["selection-changed"]);

const shown = ref(false);

const title = computed(() =>
  props.canCreateTeams ? "Pick a different team:" : "Pick a different team:",
);

function open(): void {
  shown.value = true;
}

function close(): void {
  shown.value = false;
}

function cancel(): void {
  close();
}

function handleTeamClick(teamSelected: TeamApiModel): void {
  emit("selection-changed", teamSelected);
}

function getTeamHomeUrl(team: TeamApiModel): string {
  // eslint-disable-next-line no-script-url
  return props.navigateOnClick ? `/home?view=TeamDashboard&team=${team.id}` : "javascript:void(0)";
}

defineExpose({
  open,
  cancel,
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import "../styles/bootstrap/variables.less";

.team-picker-dialog {
  @media screen and (min-width: @screen-xs-min) {
    padding-left: 80px;
  }
}

.list-container {
  max-height: 300px;
  min-height: 200px;
  overflow-y: auto;
  margin-top: 20px;
  border: 1px solid lightgray;

  .list-item {
    display: flex;
    align-items: center;
    padding: 10px;
    cursor: pointer;
    user-select: none;

    &.selected {
      color: @link-color;
      font-weight: bold;
    }

    &:hover {
      background-color: #eeeeee;
      // color: @brand-primary !important;
    }
  }
}

.create-team-image {
  height: 1em;
}

.create-team-button {
  float: left;
}

.team-image-container {
  display: inline-block;
  margin: 0 10px 0 0;
  height: 2em;

  .team-image {
    width: 100%;
  }
}

.team-name {
  margin-top: 2px;
}
</style>
